import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material'
import ReactTable from './ReactTable'
import fetchFromAthena from '../functions/FetchFromAthena'
import { useCommentCols, useLandmarkCommentCols } from '../hooks/CommentCols'

export default function CommentDialog(props) {
  const [open, setOpen] = useState(false)
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const erp = props.erp || 'lawson'
  const lawsonCommentCols = useCommentCols()
  const landmarkCommentCols = useLandmarkCommentCols()

  const query = () => {
   if(erp === 'lawson') {
    return 'sys_comments_read'
   } else if(erp === 'landmark') {
    return 'lm_sys_comments_read'
   }
  }

  const headers = () => {
    if(erp === 'lawson') {
      return {
        fileName: props.fileName,
        index: props.index
      }
    }
  else if(erp === 'landmark') {
    return {
      module: props.module,
      screen: props.screen,
      entity: props.entity,
      id: props.id
    }
  }
  }
  const columns = erp === 'landmark' ? landmarkCommentCols : lawsonCommentCols

  
  const handleClick = async () => {
    setOpen(true)
    setIsLoading(true)
    
    try {

      const queryName = query()
      const headersValue = headers()
      const result = await fetchFromAthena({
        queryName: queryName,
        headers: headersValue,
        accessToken: props.accessToken,
        credentials: props.fetchInitialData.credentials
      })

      setData(result || [])
    } catch (error) {
      console.error('Error fetching comments:', error)
      setData([])
    } finally {
      setIsLoading(false)
    }
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <div
        className="editLink"
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
      >
        {props.text}
      </div>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xl"
        fullWidth
        scroll="body"
      >
        <DialogTitle>Comments</DialogTitle>
        <DialogContent>
          <ReactTable
            cols={columns}
            data={data}
            isLoading={isLoading}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

